import styled from 'styled-components';

export const FieldLabel = styled.label`
    ${(props) => props.theme.typography.smallTextBold}
    color: ${(props) => props.theme.palette.textMain};
    text-align: left;
`;
